import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./components/index"
import ToastShow from '@/components/ToastShow.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
//基准大小
const baseFontSize = 20
import {getAesString,decryptAesString} from '@/utils/encryption'
//设置 rem 函数
function setResponsiveFontSize() {
  const baseWidth = 1920; // 基准宽度
  // const baseFontSize = 24; // 基准字体大小
  const currentWidth = window.innerWidth;
  const scaleFactor = currentWidth / baseWidth;

  document.documentElement.style.fontSize = baseFontSize * scaleFactor + 'px';
}

// 初始化时执行一次
setResponsiveFontSize();

// 监听窗口大小变化
window.addEventListener('resize', setResponsiveFontSize);
Vue.prototype.$bus = new Vue();
Vue.prototype.getAesString = getAesString
Vue.prototype.decryptAesString = decryptAesString
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 创建实例
const ToastConstructor = Vue.extend(ToastShow);
const toastInstance = new ToastConstructor().$mount();

// 添加到DOM
document.body.appendChild(toastInstance.$el);

// 注册为全局方法
Vue.prototype.$toast = {
  success(message, duration = 3000) {
    toastInstance.show({ message, type: 'success', duration });
  },
  error(message, duration = 3000) {
    toastInstance.show({ message, type: 'error', duration });
  },
  info(message, duration = 3000) {
    toastInstance.show({ message, type: 'info', duration });
  },
  warning(message, duration = 3000) {
    toastInstance.show({ message, type: 'warning', duration });
  }
};
